import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { questionnaireService } from '@app/core/configs/endpoints';
import { unsubscriberHelper } from '@app/core/helpers/unsubscriber.helper';
import { GetQuestionnairesHistory } from '@app/core/models/getQuestionnairesHistory.service.model';
import { PlatformService } from '@app/core/services/programmare/platform/platform.service';
import { QuestionnaireeService } from '@app/core/services/questionnaire/questionnaire.service';
import { RequestService } from '@app/core/services/request/request.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { IonInputConfig } from '@app/shared/models/components/ion-input-config';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Subscription } from 'rxjs';
import { distinctUntilChanged, first, map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-questionnaire-history-modal',
  templateUrl: './questionnaire-history-modal.component.html',
  styleUrls: ['./questionnaire-history-modal.component.scss'],
})
export class QuestionnaireHistoryModalComponent implements OnInit {

  @Input() set questionnairesHistory(v: any[]) {
    this.list$.next(v);
    this.questionnairesHistoryList = v;
  }

  @Input() appointment: any = null;
  searchForm: FormGroup = this.fb.group({
    keyword: ['', [Validators.required]],
  });

  getQuestionnairesHistory$: Subscription;
  isFetchingPerson = true;

  isSearching = false;
  config: IonInputConfig = {
    placeholder: 'Căutare chestionar',
    type: 'search',
    inputMode: 'search',
    size: 100,
    /* inputLabel: this.label, */
    clearable: true,
    inputClasses: '',
    minLength: 2,
    maxLength: 100,
    bgwhite: true,
    disabled: false,
    removeInputItemBaseLine: true,
    isInputFocused: false,
    debounce: 500,
    hidAssistiveText: true,
  };
  list$: BehaviorSubject<any[]> = new BehaviorSubject([]);

  questionnairesHistoryList$: BehaviorSubject<Array<GetQuestionnairesHistory>> = new BehaviorSubject<
  Array<GetQuestionnairesHistory>
>([]);

  questionnairesHistoryList: any[] = [];

  pageSize = 50;
  pageNo = 1;
  isLastFetch = false;

  constructor(
    public modalController: ModalController,
    private questionnaireeService: QuestionnaireeService,
    private fb: FormBuilder,
    private platformService: PlatformService,
    private iab: InAppBrowser,
    private toastService: ToastService,
    private reqS: RequestService,
  ) { }

  ngOnInit(): void {

    this.getQuestionnairesHistory();
    this.updateData();
    this.searchForm.valueChanges
      .pipe(distinctUntilChanged()) // makes sure the value has actually changed.
      .subscribe(
        (data) => {

          this.isLastFetch = false;
          this.getQuestionnairesHistory(true);
        },
        err => { },
        () => {
          this.isSearching = false;
        }
      );
  }

  getQuestionnairesHistory(newSearch: boolean = false){
    if (newSearch) {
      this.pageNo = 1;
    }
    this.getQuestionnairesHistory$ = this.reqS
    .post<any>(questionnaireService.GetQuestionnairesHistory, {
      personUID : this.appointment.personUID,
      searchString: this.searchText || '',
      pageSize: this.pageSize,
      pageNo: this.pageNo
    }).pipe(
      map((data: GetQuestionnairesHistory[]) => {
        if (data.length < 50) {
          this.isLastFetch = true;
        }
        return data

        .sort((a: GetQuestionnairesHistory, b: GetQuestionnairesHistory) => a?.questionnaireName.localeCompare(b?.questionnaireName)
        );
      }),


    )
    .subscribe(
      (d) => {
        if (d && d?.length > 0) {
          const list = newSearch ? d : [...this.questionnairesHistoryList$.value, ...d];
          this.questionnairesHistoryList$.next([
            ...list
          ]);
        }

          // call update
          this.updateData();

        this.isFetchingPerson = false;
      },
      (_err) => {
        this.toastService.presentToastWithDurationDismiss(
          'A apărut o eroare. Va rugăm să reîncercați.'
        );
        this.isFetchingPerson = false;
      }
    );

  }


  updateData() {
    if (this.questionnairesHistoryList$.value.length > 0) {
      this.list$.next([...this.questionnairesHistoryList$.value]);
    }  else {
      this.list$.next([...this.questionnairesHistoryList$.value]);
    }
  }

  goBack() {
    this.modalController.dismiss();
  }

  get searchText(): string {
    return this.searching && this.searchForm.controls?.keyword?.value;
  }

  searching(st: string): any[] {
    return this.questionnairesHistoryList$.value.filter(
      (v: any) =>
        v.questionnaireName
          .replace(/\s/g, '')
          .toLowerCase()
          .includes(st.toLowerCase()) ||
        v.physicianLastName
          .replace(/\s/g, '')
          .toLowerCase()
          .includes(st.toLowerCase()) ||
          v.physicianFirstName
          .replace(/\s/g, '')
          .toLowerCase()
          .includes(st.toLowerCase()) ||
        st
          .toLowerCase()
          .includes(v.physicianLastName.replace(/\s/g, '').toLowerCase()) ||
          st
          .toLowerCase()
          .includes(v.physicianFirstName.replace(/\s/g, '').toLowerCase()) ||
        st
          .toLowerCase()
          .includes(v.questionnaireName.replace(/\s/g, '').toLowerCase())
    );
  }

  openIAB(url, type: '_blank' | 'self' = 'self') {
    const options =
      `location=no,footer=yes,hardwareback=no,hidenavigationbuttons=yes,clearcache=yes,
      clearsessioncache=yes,toolbar=yes,closebuttoncaption=Close,toolbarposition=top`;
    const browser = this.iab.create(url, type, options);
    browser.show();
    if (browser) {
      const sub1 = browser.on('loadstart').subscribe((e) => {
        browser.insertCSS({ code: '.header__cancel{ display: none;}' });
        // TODO: any other action required
      });
      const sub2 = browser.on('loadstop').subscribe((e) => {
        browser.insertCSS({ code: '.header__cancel{ display: none;}' });
      });
      const sub3 = browser.on('loaderror').subscribe((e) => {
        browser.close();
        this.toastService.presentToastWithDurationDismiss('Eroare la încărcarea chestionarului', 'error');
      });
      browser
        .on('exit')
        .pipe(first())
        .subscribe((e) => {
          unsubscriberHelper(sub1);
          unsubscriberHelper(sub2);
          unsubscriberHelper(sub3);
        });
    }
  }

  openQuestionnaire(q) {
    this.questionnaireeService.getQuestionnaireHistoryUrl(q.bL_QuestionnaireSessionID,)
      .pipe(
        tap((v) => v))
      .subscribe(
        (res: any) => {
          if (this.platformService.isWeb$.getValue()) {
            this.openIAB(res, 'self');
          } else {
            this.openIAB(res, '_blank');
          }
        }
      );
  }

}
